import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Mici::BaseSummary @patient={{@patient}} @title=\"Historique des questionnaires RCH\" @feature=\"mici\" @component=\"rch-survey-consult-form\" @modelName=\"rch-survey-filled-journal-event\" />", {
  moduleName: "core/components/mici/rch-survey-summary/index.hbs"
});